import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../api";
import LinkResult from "./LinkResult";
import { btnDanger, btnGhost, fmtDateTime } from "./ui";

function FamilyCard({ fam, onChange }) {
  const [link, setLink] = useState(null);
  const [err, setErr] = useState("");
  const act = async (fn) => {
    try {
      setErr("");
      await fn();
    } catch (ex) {
      setErr(formatApiError(ex));
    }
  };
  const revoke = () =>
    window.confirm(`¿Revocar el acceso de ${fam.email}? Se cerrarán sus sesiones.`) &&
    act(async () => {
      await api.post(`/families/${fam.id}/revoke`);
      setLink(null);
      onChange();
    });
  const reactivate = () =>
    window.confirm(`¿Reactivar el acceso de ${fam.email}? Luego generá un enlace de contraseña.`) &&
    act(async () => {
      await api.post(`/families/${fam.id}/reactivate`);
      onChange();
    });
  const unlink = (sid) =>
    act(async () => {
      await api.post(`/families/${fam.id}/unlink`, { studentId: sid });
      onChange();
    });
  const reset = () =>
    act(async () => {
      const { data } = await api.post(`/users/${fam.id}/reset-link`);
      setLink(data);
    });

  return (
    <div className="p-4 rounded-2xl bg-white border border-[#132C44]/10" data-testid={`eid-family-${fam.email}`}>
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <div className="font-semibold text-[14px]">{fam.email}</div>
          <div className="text-[11px] text-[#132C44]/60">
            {fam.isActive ? "Activo" : "Revocado"} · Último ingreso: {fmtDateTime(fam.lastLoginAt)}
          </div>
        </div>
        {!fam.isActive && (
          <button onClick={reactivate} className={btnGhost} data-testid={`eid-family-reactivate-${fam.email}`}>Reactivar acceso</button>
        )}
        {fam.isActive && (
          <div className="flex gap-2">
            <button onClick={reset} className={btnGhost} data-testid={`eid-family-reset-${fam.email}`}>Enlace de contraseña</button>
            <button onClick={revoke} className={btnDanger} data-testid={`eid-family-revoke-${fam.email}`}>Revocar acceso</button>
          </div>
        )}
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        {fam.students.map((s) => (
          <span key={s.id} className="inline-flex items-center gap-2 text-[12px] px-3 py-1 rounded-full bg-[#F6EFDF]">
            {s.firstName} {s.lastName}
            {fam.isActive && (
              <button onClick={() => unlink(s.id)} className="text-[#9B2C3B] font-semibold" data-testid={`eid-family-unlink-${s.studentCode}`}>
                Desvincular
              </button>
            )}
          </span>
        ))}
        {!fam.students.length && <span className="text-[12px] text-[#132C44]/60">Sin alumnos vinculados</span>}
      </div>
      {err && <div className="mt-2 text-[12px] text-[#9B2C3B]">{err}</div>}
      <LinkResult result={link} testId={`eid-family-link-${fam.email}`} />
    </div>
  );
}

export default function FamiliesPanel({ studentId }) {
  const [families, setFamilies] = useState([]);
  const load = () => api.get("/families").then(({ data }) => setFamilies(data));
  useEffect(() => {
    load();
  }, []);
  const shown = studentId ? families.filter((f) => f.studentIds.includes(studentId)) : families;
  return (
    <div className="space-y-3" data-testid="eid-admin-families">
      {shown.map((f) => <FamilyCard key={f.id} fam={f} onChange={load} />)}
      {!shown.length && <p className="text-[13px] text-[#132C44]/60">No hay cuentas familiares.</p>}
    </div>
  );
}
